import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import EditIcon from 'assets/filledPencilIcon.svg';
import { Field, Visible } from 'coreOld/components';
import { ENTER_KEYCODE } from 'coreOld/constants';
import { Icon } from 'coreOld/elements';
import { InputType } from 'coreOld/enums';
import { PartNumberHelper } from 'partsOld/helpers';
import { partsService } from 'partsOld/services';
import { IPart, IPartAutocomplete } from 'partsOld/types';

import {
  Description,
  FlexColumn,
  Info,
  PartName,
  Wrapper,
  Image,
  InputWrapper,
  controlStyle,
  searchIconStyle,
} from './partInfoStyle';

interface IProps {
  isEditable?: boolean;
  isEditMode: boolean;
  setIsEditMode: Dispatch<SetStateAction<boolean>>;
  setSelectedPart?: Dispatch<SetStateAction<IPartAutocomplete>>;
  part: Partial<IPart>;
  selectedPart?: IPartAutocomplete;
  searchPart?: () => void;
}

const PartInfoView = ({
  setSelectedPart,
  part,
  isEditable,
  setIsEditMode,
  isEditMode,
  selectedPart,
  searchPart,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <FlexColumn>
        <PartName>
          <Visible when={!isEditMode}>
            {PartNumberHelper.toLabel(part?.number)}

            <Visible when={isEditable}>
              <Image src={EditIcon} onClick={() => setIsEditMode((prev) => !prev)} />
            </Visible>
          </Visible>

          <Visible when={isEditMode}>
            <InputWrapper>
              <Field
                name="part"
                type={InputType.ASYNC_SELECT}
                inputProps={{
                  getOptions: partsService.getManyAutocomplete,
                  onChange: (value) => setSelectedPart(value),
                  onBlur: () => {
                    if (part || selectedPart) {
                      setIsEditMode(false);
                    }
                  },
                  onIconClick: (e) => {
                    e.preventDefault();
                    searchPart();
                  },
                  onKeyDown: (e) => {
                    if (e?.keyCode === ENTER_KEYCODE) {
                      searchPart();
                    }
                  },
                  getLabel: (opt) => opt?.number,
                  getValue: (opt) => opt,
                  requestPayload: {
                    manufacturerIncluded: 1,
                  },
                  value: part,
                  isMulti: false,
                  isClearable: false,
                  startIcon: <Icon name={Icon.SEARCH} />,
                  fontInherit: true,
                  placeholder: t('labelSelectPart'),
                  controlStyle,
                  iconStyle: searchIconStyle,
                }}
              />
            </InputWrapper>
          </Visible>
        </PartName>

        <Description>{part?.descriptionLong}</Description>

        <Info>{part?.manufacturerName}</Info>
      </FlexColumn>
    </Wrapper>
  );
};

export default PartInfoView;
